import { AlertCircle } from 'lucide-react'

/**
 * Inline status under the header. An apply error wins; otherwise a failed restore of the photo's
 * saved effects; otherwise the catalog fell back to defaults. Renders nothing when all is well.
 */
export function PhotoEffectsStatusBanner({
  applyError,
  restoreFailed,
  catalogWarning,
}: {
  applyError: string | null
  restoreFailed: boolean
  catalogWarning: boolean
}) {
  if (!(catalogWarning || applyError || restoreFailed)) return null

  return (
    <div
      className="flex w-full flex-row items-start gap-2 rounded-md bg-[#FAFAFA] px-2 py-1.5 text-xs text-[#737373]"
      role="status"
    >
      <AlertCircle className="mt-0.5 size-3.5 shrink-0" aria-hidden="true" />
      <span>
        {applyError ??
          (restoreFailed
            ? 'Could not restore saved effects. Adjust and try again.'
            : 'Effect list unavailable — using defaults.')}
      </span>
    </div>
  )
}
